import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { http } from '@/lib/api/client'

export type WebsiteDays = 1 | 7 | 30 | 90

export interface WebsiteStats {
  days: WebsiteDays
  totals: { visitors: number; pageviews: number; visits: number }
  series: { start: string; end: string; visitors: number; pageviews: number }[]
  funnel: { key: string; label: string; count: number }[]
  accounts_from_free_audit: number
  pages: { path: string; views: number; visitors: number }[]
  channels: { channel: string; visits: number }[]
  referrers: { host: string; visits: number }[]
  campaigns: { source: string | null; medium: string | null; campaign: string; visits: number }[]
  countries: { value: string; visitors: number }[]
  devices: { value: string; visitors: number }[]
  browsers: { value: string; visitors: number }[]
  actions: { name: string; count: number; visitors: number }[]
  keep_days: number
}

export function useWebsiteStats(days: WebsiteDays) {
  return useQuery({
    queryKey: ['website-stats', days],
    queryFn: async () => (await http.get<{ data: WebsiteStats }>('/website-stats', { days })).data,
    placeholderData: keepPreviousData,
  })
}
